import { Box, styled } from "@mui/material";

import { COLORS, RADIUS, SHADOW } from "../../CreationModal.constants";
import { transientOptions } from "../../CreationModal.styled";

export const Tile = styled(
    Box,
    transientOptions,
)<{ $size: number }>(({ $size }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: $size,
    height: $size,
    borderRadius: RADIUS.md,
    backgroundColor: COLORS.slate50,
    border: `1px solid ${COLORS.slate200}`,
    boxShadow: SHADOW.xs,
    overflow: "hidden",
    "& img": {
        width: Math.round($size * 0.6),
        height: Math.round($size * 0.6),
        objectFit: "contain",
    },
    "& img.emblem-wordmark": {
        width: "88%",
        height: "auto",
        maxHeight: "70%",
    },
    "& .emblem-fallback": {
        fontSize: Math.round($size * 0.35),
        fontWeight: 700,
        color: COLORS.slate600,
        letterSpacing: "-0.02em",
    },
}));
